<template>
	<div class="d-flex flex-row align-content-center px-0">
		<botao-tooltip
			icone="mdi-pencil"
			cor="grey"
			texto="Editar"
			@click="editar"
			v-az-auth="permissoes.fiscaisEditar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-download"
			cor="grey"
			texto="Baixar Anexos"
			@click="baixar"
			v-az-auth="permissoes.fiscaisBaixar"
		></botao-tooltip>
		<botao-tooltip
			v-if="item.situacao === situacoes.FISCAIS.ATIVO.value"
			icone="mdi-delete"
			cor="grey"
			texto="Excluir"
			@click="excluir"
			v-az-auth="permissoes.fiscaisExcluir"
		></botao-tooltip>
	</div>
</template>
<script>
import { situacoes } from '@/core/constants'

export default {
	name: 'fiscais-listagem-botoes-acoes',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	emits: ['editar', 'baixar', 'excluir'],
	computed: {
		situacoes() {
			return situacoes
		},
	},
	methods: {
		editar() {
			this.$emit('editar', this.item.id)
		},
		baixar() {
			this.$emit('baixar', this.item.id)
		},
		excluir() {
			this.$emit('excluir', this.item.id)
		},
	},
}
</script>
